import * as Res from "@discovery/sonic-api-ng/lib/japi/response";
import * as Optics from "@discovery/sonic-api-ng-optics";
import * as M from "@discovery/prelude/lib/data/maybe";
import { Fold, Lens } from "@discovery/prelude/lib/control/lens";
import { updateGlobalState } from "@discovery/common-dplus/lib/hooks";
import * as RTE from "fp-ts/ReaderTaskEither";
import { pipe } from "fp-ts/function";
import * as UserEntitlements from "@discovery/sonic-api-ng/lib/api/entitlements/user-entitlements/";
const _UserEntitlements = Fold.compose(Optics._UserEntitlementResponse2UserEntitlement, Res._Response(), Lens.path("attributes", "hasActiveAcquiredCapabilities"), M._Just());
const userEntitlements = (userEntitlementRes) => {
    const userEntitlementsM = Fold.preview(_UserEntitlements, userEntitlementRes);
    const hasActiveAcquiredCapabilities = M.fromMaybe(userEntitlementsM, false);
    updateGlobalState(Lens.prop("isUserPremiumFromPartners"))((_IsUserPremiumFromPartners) => hasActiveAcquiredCapabilities);
};
export const userEntitlementsReq = pipe(UserEntitlements.Endpoints.getUserEntitlements(), RTE.chain((userEntitlementRes) => RTE.fromIO(() => userEntitlements(userEntitlementRes))));
